import area from "../assets/js/area"

const areaUtils = {
  getAllArea() {
    return area
  },
  getAllProvince() {
    let provinceList = []
    area.forEach(province => {
      provinceList.push({
        value: province.code,
        label: province.name
      })
    });
    return provinceList;
  },
  getAllCityByProvinceCode(provinceCode) {
    let cityList = []
    area.forEach(province => {
      if (province.code === provinceCode) {
        province.cityList.forEach(city => {
          cityList.push({
            value: city.code,
            label: city.name
          })
        })
      }
    });
    return cityList;
  },
  getAllCountyCityCode(provinceCode, cityCode) {
    let countyList = []
    area.forEach(province => {
      if (province.code === provinceCode) {
        province.cityList.forEach(city => {
          if (city.code === cityCode) {
            city.areaList.forEach(county => {
              countyList.push({
                value: county.code,
                label: county.name
              })
            })
          }
        })
      }
    });
    return countyList;
  }
}
export default areaUtils;



// WEBPACK FOOTER //
// ./src/util/area.js